'use client';
import classNames from 'classnames';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import { useEffect, useState } from 'react';
import SearchAIcon from './SearchAIcon';

export default function SearchV1({ prefixCls }: { prefixCls: string }) {
    const [openA, setOpenA] = useState(false);
    const classes = classNames(`${prefixCls}-bar-item ${prefixCls}-bar-search`, {
        [`${prefixCls}-search-open`]: openA,
    });
    const toggleHandle = () => {
        const openA2 = !openA;
        setOpenA(openA2);
        EcoDesignEventsBus.emit('ef-header-nav-close');
    };
    useEffect(() => {
        EcoDesignEventsBus.on('ef-header-search-close', () => {
            setOpenA(false);
        });
    }, []);
    return (
        <button className={classes} onClick={toggleHandle} aria-label="search">
            <SearchAIcon />
        </button>
    );
}
